import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import Button from '../../components/General/Button'
import FormItem from '../../components/Form/FormItem'
import RawAutoComplete from '../../components/Inputs/RawAutoComplete'

const AddEmployeePayrollForm: React.FC<IAddEmployeeComponent> = ({
  onCancel,
  onSubmit,
  loadingAddemployee
}) => {
  const form = useForm<IAddEmployeePayrollForm>()

  const [selectedEmployee, setSelectedEmployee] = useState<IEmployeeResponse | null>(null)

  const onSubmitForm = () => {
    if (selectedEmployee) {
      onSubmit(selectedEmployee)
    } else {
      form.setError("employee", {message: "Empleado requerido"})
    }
  }

  return (
    <Form classes="gap-x-5" form={form} onSubmit={onSubmitForm}>
      <FormItem
        name="employee"
        classes="col-span-12"
        rules={{ required: 'Es necesario el empleado' }}
      >
        <RawAutoComplete
          label="Empleado"
          url={`employee`}
          bodyGet={'employees'}
          queryParam={'search'}
          selectedValue={undefined}
          setSelectedValue={(value: IEmployeeResponse) => {
            setSelectedEmployee(value)
          }}
        />
      </FormItem>

      <div className="col-span-12 h-full flex flex-row mt-5">
        <div className="w-1/2 mr-5 pl-1">
          <Button
            onClick={() => {
              onCancel()
            }}
            type="outline"
            classes="w-full"
          >
            Cancelar
          </Button>
        </div>
        <div className="w-1/2 pr-1">
          <Button
            type="primary"
            loading={loadingAddemployee}
            classes="w-full"
            htmlType="submit"
          >
            Añadir
          </Button>
        </div>
      </div>
    </Form>
  )
}

interface IAddEmployeePayrollForm {
  employee: IEmployeeResponse
}

interface IEmployeeResponse {
  id: number
  name: string
  address: string
  document: string
  email: string
  phone: string
  hireDate: string
  baseSalary: string
  currencyId: number
  salaryFreq: string
  birthDate: string
  bankAccountNumber: string
  bankCode: string
  isActive: boolean
  jobPosition: string
}

interface IAddEmployeeComponent {
  onCancel: () => void
  onSubmit: (employee: IEmployeeResponse) => void
  loadingAddemployee: boolean
}

export default AddEmployeePayrollForm
